import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

interface Props {
  checked: boolean;
}

export const RadioGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RadioButtonLabel = styled.label<Props>`
  display: flex;
  align-items: center;
  margin-bottom: ${themeGet('space.3')}px;
  cursor: pointer;
  border: 1px solid ${({ checked }) => (checked ? themeGet('colors.border.primary') : themeGet('colors.glassDark.2'))};
  border-radius: ${themeGet('radii.4')}px;
  padding: ${themeGet('space.2')}px ${themeGet('space.3')}px;
  font-size: ${themeGet('fontSizes.1')}px;
`;

export const RadioButtonInput = styled.input`
  display: none;
`;

export const RadioButtonIndicatorWrapper = styled.span<Props>`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-left: auto;
  border: 1px solid;
  border-color: ${({ checked }) => (checked ? themeGet('colors.glassDark.8') : themeGet('colors.glassDark.4'))};
  border-radius: 50%;
  position: relative;
`;

export const RadioButtonIndicator = styled.span<Props>`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: ${({ checked }) => (checked ? themeGet('colors.primary') : 'transparent')};
  position: absolute;
  top: 0;
  left: 0;
  transform: ${({ checked }) => (checked ? 'scale(1)' : 'scale(0)')};
  transition: transform 0.2s ease-in-out;
`;
